import { BaseAuthApi } from './api.base';
import { apiNet } from '@cems-eco/core/src/services/api';
import axios from "axios";

export class CloudAuthApi extends BaseAuthApi {


    getUrl(endpoint: string, params: any  = {}) {
        return apiNet.getUrl(endpoint, params);
    }

    async healthcheck(hash: string) {
        return new Promise(async (resolve, reject) => {
            const headers: any = {
                responseType: "json",
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            };
            const params = { hash };
            const url = this.getUrl(`/healthcheck`, params);
            axios.get(url, headers).then((response: any) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err);
            });
        });
    }
}
